import React, { useEffect, useState } from 'react';
import { firebase } from '../../firebase';
import { Button, Modal, ModalHeader, ModalBody} from 'reactstrap';


import NavWorker from './NavWorker';
import BlueButton from '../BlueButton';
import HomeTwo from '../Map/HomeTwo';

import cubre from '../../img/cubre.svg';
import metro from '../../img/1m.svg';
import gel from '../../img/gel.svg';
import casa from '../../img/casa.svg';

const WorketView = (props) => {

    const {
        buttonLabel,
        className
    } = props

    const toggle = () => setModal(!modal);
    const [modal, setModal] = useState(true);


    const [service, setService] = useState(null);



    useEffect(() => {
        fetchService();
    }, []);

    const fetchService = async () => {
        try {
            const res = await firebase.firestore().collection('services').limit(1).get();
            const arrayUsers = res.docs.map(doc => doc.data());
            setService(arrayUsers);

        } catch (error) {
            console.log(error);
        }
    };

    /*  const lol = service[0];
     console.log(lol); */

    return (
        <div>
            <NavWorker />
            <div>
            </div>


            <HomeTwo />

            <Modal isOpen={modal} toggle={toggle} className={className}>
                        <ModalHeader toggle={toggle}>Regulaciones COVID-19<span className="material-icons dangr">
                            error_outline
                            </span></ModalHeader>
                        <ModalBody >
                            Nuestros usuario y socios deben atender las siguientes medidas preventivas:

                            
                            <div className='row'>
                    <img src={cubre} className='modal-img col-3' alt='cubre' />
                    <p className='col-9'>
                    Uso de obligatorio de cubrebocas.
                    </p>
                    </div>

                    <div className='row'>
                    <img src={metro} className='modal-img col-3' alt='distance'/>
                    <p className='col-9'>
                    Mantenerse a una distancia mínima de un metro.</p>
                    </div>

                    <div className='row'>
                    <img src={gel} className='modal-img col-3' alt='gel'/>
                    <p className='col-9'>
                    Lavarse las manos con frecuencia y usar gel desinfectante.</p>
                    </div>


                    <div className='row'>
                    <img src={casa} className='modal-img col-3' alt='house' />
                    <p className='col-9'>
                    Quedarse en casa en caso de presentar fiebre, tos o dolor de cabeza.</p>                    
                    </div>
                            <div>

                            </div>
                        </ModalBody>
                    </Modal> 



            <div className=' blue-bg'>

             <div>
 <div className=' d-flex justify-content-center mt-5'>
                    <h4 className='text-white'>Hay un servicio disponible</h4>
                </div>
                <div className=' container'>
                    <div className='buttons-2 d-flex justify-content-around'>
                        <Button variant="text" className=' init-btn btn-light' color="primary">
                            <span className="material-icons icon-ui">
                                directions_car
                        </span>
                            <span className='txt'>Ford-Fiest</span>
                    </Button>
                        <Button variant="text" className=' init-btn btn-light '>
                            <span className="material-icons icon-ui  ">
                                credit_card
                    </span>
                            <span className='txt'>**** **54</span>
                        </Button>
                    </div>
                    <div className='container'>
                        <Button variant="text" className='mt-3 btn-light' color="primary">
                            <span className="material-icons icon-ui">
                                pin_drop
                        </span>
                            <span className='txt'>Polanco, CDMX</span>
                        </Button>
                    </div>
            
                    <div className='mt-3'>
                        <BlueButton label={'Aceptar servicio'} onClick={() => alert('¡Vamos alla!')}  />
                    </div>
                </div>
                    </div>
                


               


                
            </div>


        </div>
    );
};

export default WorketView;
